import './components'
import './lib/polyfills'
import './lazyload'
import './lib/cookies'
import * as cookies from './lib/cookies'

addEventListener('DOMContentLoaded', (event) => {
    initializeForms()
    initMenu()
    projectsButton()
    projectFilter()
    switchButton()
    toggleFilter()
    hideMenu()
    pollShowAll();
})

// Mark a <form> with the class `busy` when it's being submitted.
function initializeForms() {
    const forms = Array.from(document.querySelectorAll('form')) as HTMLElement[]
    for (const form of forms) {
        form.addEventListener('submit', function (event) {
            if (document.activeElement) {
                (document.activeElement as HTMLElement).blur()
                console.log(document.activeElement)
            }

            this.classList.add('busy')
        })
    }
}

function hideMenu() {
    const btn = document.querySelector('.toggle-nav')
    const nav = document.querySelector('nav')
    const content = document.querySelector('#content')
    let openedNav = cookies.get('open_menu')
    const projectsBtn = document.querySelector('.projects-button')
    const projectsBlock = document.getElementById('projects-block')

    if (window.innerWidth <= 768) {
        cookies.set('open_menu', 'false', 365)
        nav.classList.remove('show')
        content.classList.remove('opened-nav')
        projectsBtn.classList.remove('opened-nav')
        projectsBlock.style.left = ''
    } else {
        if (openedNav == 'true') {
            nav.classList.toggle('show')
            content.classList.toggle('opened-nav')
            projectsBtn.classList.toggle('opened-nav')
            projectsBlock.style.left = ''
        }

        if (openedNav !== 'true') {
            projectsBlock.style.left = 150 + 'px'
        }

        if (btn) {
            btn.addEventListener('click', () => {
                nav.classList.remove('first')
                content.classList.remove('first')
                projectsBtn.classList.remove('first')

                nav.classList.toggle('show')
                content.classList.toggle('opened-nav')
                projectsBtn.classList.toggle('opened-nav')
                projectsBlock.style.left = ''


                if (nav.classList.contains('show')) {
                    cookies.set('open_menu', 'true', 365)

                } else {
                    cookies.set('open_menu', 'false', 365)
                }
            })
        }
    }



}

function toggleFilter() {
    const btn = document.querySelector('.filter-button')
    const filter = document.querySelector('.filter-component > form ') as HTMLElement ?? null

    if (filter) {
        const filterHeight = filter.clientHeight
        filter.style.maxHeight = '0px'
        filter.style.overflow = 'hidden'

        btn.addEventListener('click', () => {

            if (!btn.classList.contains('active')) {
                filter.style.maxHeight = 'inherit'
                filter.style.overflow = 'unset'

            } else {
                filter.style.maxHeight = '0px'
                filter.style.overflow = 'hidden'
            }

            btn.classList.toggle('active')
            filter.classList.toggle('show')
        })
    }

}

function switchButton() {
    const btn = document.querySelector('.switch-clients-btn')
    const popup = document.getElementById('userblock')
    const overlay = document.querySelector('.overlay-clients')

    if (btn) {
        btn.addEventListener('click', () => {
            popup.classList.toggle('show')
            overlay.classList.toggle('show')
        })
    }

    if (overlay) {
        overlay.addEventListener('click', () => {
            popup.classList.remove('show')
            overlay.classList.remove('show')
        })
    }
}

function projectFilter() {
    const search = document.getElementById('search') as HTMLInputElement
    const projects = document.querySelectorAll('.projects > li > .project')

    if (search) {
        search.addEventListener('input', function () {
            const filter = search.value.toLocaleLowerCase()
            projects.forEach((item) => {
                if (item.textContent.toLocaleLowerCase().includes(filter)) {
                    item.parentElement.classList.remove('hide')
                } else {
                    item.parentElement.classList.add('hide')

                }
            })
        })
    }
}

function projectsButton() {
    const btn = document.getElementsByClassName('projects-button')[0]
    const projectsBlock = document.getElementById('projects-block')
    const overlay = document.getElementsByClassName('overlay-projects')[0]

    if (btn) {
        btn.addEventListener('click', () => {
            projectsBlock.classList.toggle('show')
            overlay.classList.toggle('show')
        })
    }

    if (overlay) {
        overlay.addEventListener('click', () => {
            overlay.classList.remove('show')
            projectsBlock.classList.remove('show')

        })
    }
}

function initMenu() {
    const header = document.querySelector('header')

    addEventListener('scroll', (event) => {
        const y = window.scrollY || document.body.scrollTop
        const className = 'compact'

        if (y > 50 && !header.classList.contains(className)) {
            header.classList.add(className)
        }
        else if (y <= 50 && header.classList.contains(className)) {
            header.classList.remove(className)
        }
    })
}

function pollShowAll() {
    const showAllButtons = document.getElementsByClassName('all-answers-header');
    for (let i = 0; i < showAllButtons.length; i++) {
        const button = showAllButtons[i];
        const answerDiv = Array.from(button.parentElement.getElementsByClassName('all-answers'));

        if (answerDiv.length == 0) {
            continue;
        }

        button.addEventListener('click', () => {
            answerDiv[0].classList.toggle('visible');
        })
    }
}